import * as React from 'react';

import styles from './iframe.module.css';

type Props = {
    url: string;
};

export function Iframe({url}: Props) {
    return <iframe src={url} className={styles.iframe} />;
}
